const PORTFOLIO_TOKEN_KEY = 'portfolio-auth-token';

export const getPortfolioToken = (): string | null => {
  return sessionStorage.getItem(PORTFOLIO_TOKEN_KEY);
};

export const setPortfolioToken = (token: string): void => {
  sessionStorage.setItem(PORTFOLIO_TOKEN_KEY, token);
};

export const clearPortfolioToken = (): void => {
  sessionStorage.removeItem(PORTFOLIO_TOKEN_KEY);
};
